import { render, staticRenderFns } from "./VDataTableDigests.vue?vue&type=template&id=b63c4ec0&scoped=true"
import script from "./VDataTableDigests.vue?vue&type=script&lang=js"
export * from "./VDataTableDigests.vue?vue&type=script&lang=js"
import style0 from "./VDataTableDigests.vue?vue&type=style&index=0&id=b63c4ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63c4ec0",
  null
  
)

export default component.exports